export const DEFAULT_JOB_SEEKER_STATE = null
